import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_22807_7287)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.0202 8.19348L11.0121 1.58803C10.3085 1.07282 9.47602 0.762505 8.60687 0.691474C7.73771 0.620443 6.86586 0.791474 6.08796 1.18561C5.31006 1.57974 4.65649 2.18159 4.19969 2.92443C3.74289 3.66727 3.50072 4.52209 3.50001 5.39414V18.6116C3.49865 19.4846 3.73956 20.3407 4.19592 21.0848C4.65228 21.8289 5.30619 22.4318 6.08485 22.8263C6.86351 23.2208 7.73639 23.3915 8.60631 23.3194C9.47623 23.2473 10.3091 22.9351 11.0121 22.4178L20.0202 15.8123C20.618 15.3737 21.104 14.8004 21.439 14.139C21.774 13.4776 21.9486 12.7467 21.9486 12.0053C21.9486 11.2639 21.774 10.5329 21.439 9.87147C21.104 9.21007 20.618 8.63685 20.0202 8.1982V8.19348Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22807_7287",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 22.6667,
			height: 22.6667,
			fill: "white",
			transform: "translate(0.666992 0.666992)"
		})
	}) })]
});
export default SvgPlay;
